// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Category Grid component
 */

  import React, { Component } from 'react';
  import connect from 'share/enhancers/Izenda.Connect';
  import PropTypes from 'prop-types';
  import classnames from 'classnames';
  import Validator from 'share/components/hoc/Izenda.Validator';
  import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
  import constants from 'logic/data/Izenda.CategoryConstants';
  import { isEmpty } from 'lodash/fp';
  import Input from 'share/components/controls/Izenda.Input';

  const ValidatorInput = Validator()(Input);

  @connect(
    { toClass: true }
  )
  export default class CategoryGrid extends Component {
    static propTypes: {
      store: PropTypes.object.isRequired
    }
    /**
     * Handle onChange for textbox on grid
     * @param {Object} event
     */
    handleChangeTextbox = (e: any, item: any) => {
      const {store} = this.props;
      store.updateCategoryName(item, e.target.value);
    }

    onAddNew = () => {
      const {store} = this.props;
      store.addEmptyCategory();
    }

    onSave = () => {
      const {store} = this.props;
      store.saveCategories();
    }

    /**
     * Handle onChange for textbox on grid
     * @param {Object} event
     */
    handleDelete = (item: any) => {
      const {store, localization} = this.props;

      this.props
        .confirmFn('Confirmation', {
          description: localization.getText('CATEGORY_MESSAGE_CONFIRM_DELETE')
        })
        .then(function() {
          store.delCategory(item);
        });
    }

    /**
     * render grid header with 2 columns: Category Name and Add new link
     */
    renderGridHeader = () => {
      const {localization} = this.props;

      return (
        <div className='izenda-CategoryGrid-header izenda-Wrapper-header'>
          <div className='column-left u_floatLeft'>
            <span className='validation required'>{localization.getText('CATEGORY_LABEL_NAME')}</span>
            <span className='icon-info-circled' title={localization.getText('CATEGORY_LABEL_NAME_TOOLTIP')} />
          </div>
          <div className='u_floatRight'>{this.renderHeaderAddButton()}</div>
        </div>
      );
    }

    /**
     * render add new button
     */
    renderHeaderAddButton = () => {
      const {localization} = this.props;

      return (
        <a onClick={this.onAddNew} className='link-add'>
          {localization.getText('CATEGORY_LABEL_ADD_NEW')}
          <span className='icon-addnew' />
        </a>
      );
    }

    /**
     * render category grid
     */
    renderGrid = () => {
      const {store} = this.props;
      const categories = store.categoryMetadatas;
      const cats = categories.map(
        (item, index) => {
          {
            return this.renderCatItem(item, index);
          }
        }
      );

      return (
        <div className='izenda-Wrapper-content'>
          <ScrollBox>
            <div className='u_table u-bgWhite izenda-CategoryGrid-content'>{cats}</div>
          </ScrollBox>
        </div>
      );
    }

    /**
     * render category item
     */
    renderCatItem = (item: any, index: any) => {
      /**
       * handle textbox event
       */
      const textChange = (event) => {
        this.handleChangeTextbox(event, item);
      };

      const onDelete = () => {
        this.handleDelete(item);
      };

      const hassError = classnames('u_tableCell u_fullWidth u_borderRight u_paddingInner', {
        'has-error': !isEmpty(item.error)
      });

      const { props: { store } } = this;
      return (
        <div key={item.key} className='izenda-CategoryGrid-row u_tableRow u_alignMiddle'>
          <div className={hassError}>
            <ValidatorInput
              className='form-control'
              onChange={textChange}
              value={item.name}
              maxLength='50'
              autoFocus={item === store.lastAddCategory}
              validations={constants.CONSTRAINTS}
              field={'[' + index + '].Name'}
            />
          </div>
          <div className='u_tableCell u_paddingAll u_alignMiddle'>
            <a className='link-remove' onClick={onDelete}>
              <span className='icon-minus' />
            </a>
          </div>
        </div>
      );
    }

    /**
     * render main function
     */
    render() {
      return (
        <div className='izenda-Wrapper'>
          {this.renderGridHeader()}
          {this.renderGrid()}
        </div>
      );
    }
  }






// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Category/Izenda.CategoryGrid.js